import { listConsulting } from '@/api/industryInfo'
import { message } from 'element-ui'
export default {
  state: {
    industryList: null,
    total: 0
  },
  mutations: {
    SET_INDUSTRYSLIST (state, payload) {
      state.industryList = payload
    },
    SET_TOTAL (state, payload) {
      state.total = payload
    }
  },
  actions: {
    async getIndustryList (context, payload) {
      try {
        const res = await listConsulting({
          pageSize: payload.pageSize,
          pageNum: payload.pageNum,
          title: payload.search
        })
        console.log(res)
        if (res.code === 200) {
          context.commit('SET_INDUSTRYSLIST', res.rows)
          context.commit('SET_TOTAL', res.total)
        }
      } catch (error) {
        console.log(message)
        // message.error('未知错误，请重新尝试')
      }
    }
  },
  getters: {}
}
